<template>
	<div>
		<div class="card air__utils__shadow">
			<div class="card-body">
				<div>
					<div class="mt-3">
						<a-row type="flex" align="middle">
							<div class="mb-4">
								<div class="text-dark">Desde</div>
								<a-date-picker
									v-model="DateFrom"
									format="DD/MM/YYYY"
									:defaultValue="DateFrom"
									:disabled-date="disableStartDateBiggerThanEnd"
									@change="handleFromDate"
								/>
							</div>
							<div class="mb-4 ml-auto">
								<div class="text-dark">Hasta</div>
								<a-date-picker
									v-model="DateEnd"
									format="DD/MM/YYYY"
									:defaultValue="DateEnd"
									:disabled-date="disableDateMoreThanToday"
									@change="handleEndDate"
								/>
							</div>
							<div class="mb-4 ml-auto">
								<div class="text-dark">Network</div>
								<a-select
									style="min-width: 8rem;"
									@change="handleNetwork"
									v-model="network"
								>
									<a-select-option :value="2">
										Instagram
									</a-select-option>
									<a-select-option :value="3">
										YouTube
									</a-select-option>
									<a-select-option :value="5">
										TikTok
									</a-select-option>
									<a-select-option :value="6">
										All
									</a-select-option>
								</a-select>
							</div>
							<a-radio-group
								v-model="filterDirection"
								button-style="solid"
								class="ml-auto"
								@change="handleDirection"
							>
								<a-radio-button value="asc" block>
									<a-icon type="arrow-up" />
								</a-radio-button>
								<a-radio-button value="desc">
									<a-icon type="arrow-down" />
								</a-radio-button>
							</a-radio-group>
						</a-row>
						<span class="text-dark">Mentions: </span>
					</div>
					<div class="mt-1">
						<a-select
							v-if="!filterLoading"
							mode="tags"
							style="width: 100%;margin-bottom:20px;"
							:token-separators="[',']"
							:default-value="tags"
							@change="handleHashtags"
						>
						</a-select>
						<div v-if="filterLoading">
							<IsLoading :isLoading="filterLoading" />
						</div>
						<a-row type="flex">
							<div class="ml-auto mt-3">
								<a-button
									type="default"
									@click="handleSearch"
									:loading="filterLoading"
								>
									Buscar
								</a-button>
							</div>
						</a-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import IsLoading from '../../widgets/loading'
import moment from 'moment'
export default {
	components: {
		IsLoading,
	},
	props: {
		accounts: {
			type: Array,
			required: true,
		},
	},
	data: function() {
		return {
			filterLoading: true,
			moment,
			network: 2,
			tags: [],
			DateFrom: moment()
				.utc()
				.subtract(20, 'days'),
			DateEnd: moment().utc(),
			filterDirection: 'desc',
		}
	},
	created() {
		this.getAccounts()
	},
	methods: {
		getAccounts() {
			this.accounts.map(account => {
				this.tags.push(account.ProfileName)
			})
			this.filterLoading = false
		},
		handleDirection(e) {
			this.filterDirection = e.target.value
			this.$emit('filterDirection', e)
		},
		handleNetwork(id) {
			this.network = id
			this.$emit('handleNetwork', this.network)
		},
		handleHashtags(filters) {
			this.tags = filters
			this.$emit('hashtagFilters', this.tags)
		},
		handleFromDate(filters) {
			this.DateFrom = filters
			this.$emit('filterDateFrom', this.DateFrom)
		},
		handleEndDate(filters) {
			this.DateEnd = filters
			this.$emit('filterDateEnd', this.DateEnd)
		},
		handleSearch() {
			this.$emit('go', true)
		},
		disableDateMoreThanToday(evt) {
			return this.DateFrom > moment().utc()
		},
		disableStartDateBiggerThanEnd(evt) {
			return evt >= this.DateEnd
		},
	},
	computed: {},
}
</script>

<style>
.ant-pagination {
	margin-right: 20px !important;
}
.top-week .ant-table-tbody tr td {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}
</style>
